import React from "react";

// Sort an array of row objects by `key`. Detects numbers (incl. "85%", "12 tests",
// epoch strings) and sorts numerically; otherwise case-insensitive string compare.
// `dir` is "asc" | "desc"; an empty key/dir returns the rows untouched.
export function sortRows(rows, key, dir) {
  if (!key || !dir || !Array.isArray(rows)) return rows || [];
  const num = (v) => {
    if (v == null || v === "") return null;
    if (typeof v === "number") return v;
    const s = String(v);
    if (!/[0-9]/.test(s)) return null;
    const n = parseFloat(s.replace(/[^0-9.\-]/g, ""));
    return isNaN(n) ? null : n;
  };
  const out = [...rows].sort((a, b) => {
    const av = a ? a[key] : null;
    const bv = b ? b[key] : null;
    const an = num(av), bn = num(bv);
    if (an != null && bn != null) return an - bn;
    if (an != null) return -1;          // numbers before blanks/strings
    if (bn != null) return 1;
    const as = (av == null ? "" : String(av)).toLowerCase();
    const bs = (bv == null ? "" : String(bv)).toLowerCase();
    return as < bs ? -1 : as > bs ? 1 : 0;
  });
  return dir === "desc" ? out.reverse() : out;
}

// Toggle helper for sort state: same key flips asc<->desc, new key starts asc.
export function nextSort(state, key) {
  if (state.sortKey !== key) return { sortKey: key, sortDir: "asc" };
  return { sortKey: key, sortDir: state.sortDir === "asc" ? "desc" : "asc" };
}

// Clickable sortable <th>. `sortKey` is the row field this column sorts by.
export function SortTh({ label, sortKey, state, onSort, style, center }) {
  const active = state && state.sortKey === sortKey;
  const icon = !active ? "fa-sort" : state.sortDir === "asc" ? "fa-sort-up" : "fa-sort-down";
  return (
    <th
      onClick={() => onSort(sortKey)}
      style={{ ...(style || {}), cursor: "pointer", userSelect: "none", textAlign: center ? "center" : (style && style.textAlign) || "left" }}
      title="Sort"
    >
      {label} <i className={`fal ${icon}`} style={{ marginLeft: 4, opacity: active ? 1 : 0.4 }} />
    </th>
  );
}
